import {
  GET_BEARER_TOKEN_REQUEST,
  GET_BEARER_TOKEN_SUCCESS,
  LOCAL_STORAGE_BEARER_TOKEN_KEY,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  SET_BEARER_TOKEN_REQUEST,
  SET_BEARER_TOKEN_SUCCESS,
} from '../constants';
import { put, takeLatest } from 'redux-saga/effects';
import {
  IGetBearerTokenRequest,
  IGetBearerTokenSuccess,
  ILogoutSuccess,
  ISetBearerTokenRequest,
  ISetBearerTokenSuccess
} from "../reducers/bearerToken";
import { callApi } from "../api";

const onGetBearerToken = function* () {
  // debugger;
  const bearerToken = localStorage.getItem(LOCAL_STORAGE_BEARER_TOKEN_KEY);
  if (!bearerToken) {
    const googleRedirectUrl: string = yield callApi(
      '/google-auth/get-url'
    );
    console.log(googleRedirectUrl);
    window.location.replace(googleRedirectUrl);
    return;
  }

  yield put<IGetBearerTokenSuccess>({
    type: GET_BEARER_TOKEN_SUCCESS,
    bearerToken,
  });
};

const onSetBearerToken = function* (action: ISetBearerTokenRequest) {
  localStorage.setItem(LOCAL_STORAGE_BEARER_TOKEN_KEY, action.bearerToken || '');

  yield put<ISetBearerTokenSuccess>({
    type: SET_BEARER_TOKEN_SUCCESS,
  });
};

const onLogout = function* () {
  yield put<IGetBearerTokenSuccess>({
    type: GET_BEARER_TOKEN_SUCCESS,
    bearerToken: '',
  });

  localStorage.setItem(LOCAL_STORAGE_BEARER_TOKEN_KEY, '');

  yield put<ILogoutSuccess>({
    type: LOGOUT_SUCCESS,
  });
};

const watchBearerToken = function* () {
  yield takeLatest<IGetBearerTokenRequest>(GET_BEARER_TOKEN_REQUEST, onGetBearerToken);
  yield takeLatest<ISetBearerTokenRequest>(SET_BEARER_TOKEN_REQUEST, onSetBearerToken);
  yield takeLatest<ISetBearerTokenRequest>(LOGOUT_REQUEST, onLogout);
};

export {
  watchBearerToken,
};
